import React, { useEffect, useState } from "react";
import {
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon,
  ChatBubbleLeftEllipsisIcon,
} from "@heroicons/react/24/solid";
import { LineChart, Line, ResponsiveContainer } from "recharts";

const API_URL = process.env.REACT_APP_API_URL;

const statusConfig = {
  Aberto: { color: "#facc15", icon: XCircleIcon }, // amarelo
  Pendente: { color: "#ef4444", icon: ClockIcon }, // vermelho
  Finalizado: { color: "#22c55e", icon: CheckCircleIcon }, // verde
  Atendendo: { color: "#3b82f6", icon: ChatBubbleLeftEllipsisIcon }, // azul
};

const gerarDadosSparkline = () =>
  Array.from({ length: 8 }, () => ({
    value: Math.floor(Math.random() * 100),
  }));

export default function ResumoCards() {
  const [totais, setTotais] = useState({
    Aberto: 0,
    Pendente: 0,
    Finalizado: 0,
    Atendendo: 0,
  });

  useEffect(() => {
    const fetchTotais = async () => {
      try {
        const response = await fetch(`${API_URL}/Dashboard/Status.php`);
        if (!response.ok) {
          throw new Error(`Erro HTTP: ${response.status}`);
        }
        const data = await response.json();
        if (data.success && data.totais) {
          setTotais(data.totais);
        } else {
          console.error("Resposta inesperada:", data);
        }
      } catch (error) {
        console.error("Erro ao buscar status:", error);
      }
    };

    fetchTotais();
  }, []);

  return (
    <div
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4"
      style={{ fontFamily: '"Comfortaa", sans-serif', fontSize: "16px" }}
    >
      {Object.keys(totais).map((status) => {
        const Icon = statusConfig[status]?.icon;
        if (!Icon) return null;

        const atual = totais[status];
        const sparkData = gerarDadosSparkline();

        return (
          <div
            key={status}
            className="group relative overflow-hidden rounded-sm bg-white border border-gray-100 
                       shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105"
          >
            {/* Linha lateral colorida */}
            <div
              className="absolute left-0 top-0 h-full w-1"
              style={{ backgroundColor: statusConfig[status].color }}
            ></div>

            <div className="relative p-4 flex flex-col items-center">
              {/* Título + ícone na mesma linha */}
              <div className="flex items-center justify-center space-x-2 mb-2">
                <Icon
                  className="w-5 h-5"
                  style={{ color: statusConfig[status].color }}
                />
                <span
                  className="font-medium text-gray-600 uppercase tracking-wide text-sm"
                  style={{
                    fontFamily: '"Comfortaa", sans-serif',
                  }}
                >
                  {status}
                </span>
              </div>

              {/* Número centralizado */}
              <span
                className="text-xl font-bold bg-gradient-to-r bg-clip-text text-transparent mb-3"
                style={{
                  backgroundImage: `linear-gradient(135deg, ${statusConfig[status].color}, ${statusConfig[status].color}AA)`,
                  fontFamily: "Inter, sans-serif",
                }}
              >
                {atual}
              </span>

              {/* Sparkline */}
              <div className="h-8 w-full">
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart data={sparkData}>
                    <Line
                      type="monotone"
                      dataKey="value"
                      stroke={statusConfig[status].color}
                      strokeWidth={2}
                      dot={false}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
